<template>
  <span class="media-icon">
    <docIcon v-if="icon(link) === 'doc'" class="media-icon__svg"></docIcon>
    <imgIcon v-if="icon(link) === 'img'" class="media-icon__svg"></imgIcon>
    <pdfIcon v-if="icon(link) === 'pdf'" class="media-icon__svg"></pdfIcon>
    <cbIcon v-if="icon(link) === 'cb'" class="media-icon__svg"></cbIcon>
    <webIcon v-if="icon(link) === 'web'" class="media-icon__svg"></webIcon>
    <sheetIcon v-if="icon(link) === 'sheet'" class="media-icon__svg"></sheetIcon>
    <formIcon v-if="icon(link) === 'form'" class="media-icon__svg"></formIcon>
    <ytIcon v-if="icon(link) === 'yt'" class="media-icon__svg"></ytIcon>
  </span>
</template>

<script>
import docIcon from '@/assets/filetypes/ic_link_doc.svg';
import imgIcon from '@/assets/filetypes/jpg_png.svg';
import pdfIcon from '@/assets/filetypes/PDF.svg';
import cbIcon from '@/assets/filetypes/ic_link_collboard.svg';
import webIcon from '@/assets/filetypes/ic_link_default.svg';
import sheetIcon from '@/assets/filetypes/ic_link_sheet.svg';
import formIcon from '@/assets/filetypes/ic_link_form.svg';
import ytIcon from '@/assets/filetypes/ic_link_yt.svg';

export default {
  components: {
    docIcon,
    imgIcon,
    pdfIcon,
    cbIcon,
    webIcon,
    sheetIcon,
    formIcon,
    ytIcon,
  },
  props: ['link'],
  methods: {
    icon(name) {
      const imageFormats = ['jpg', 'png', 'jpeg', 'heic', 'gif'];
      const protocols = ['http://', 'https://'];

      if (imageFormats.some(format => name.toLowerCase().endsWith(format))) {
        return 'img';
      }
      if (name && name.toLowerCase().endsWith('pdf')) {
        return 'pdf';
      }
      if (name && protocols.some(protocol => name.includes(protocol))) {
        if (name.includes('collboard.com')) {
          return 'cb';
        }
        if (name.includes('docs.google.com')) {
          if (name.includes('spreadsheet')) {
            return 'sheet';
          }
          if (name.includes('forms')) {
            return 'form';
          }
          return 'doc';
        }
        if (name.includes('youtube.com') || name.includes('youtu.be')) {
          return 'yt';
        }

        return 'web';
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
.media-icon {
  align-items: center !important;
  display: flex;
  &__svg {
    width: 20px;
    padding: 2px;
    height: 20px;
  }
}
</style>
